import { render, staticRenderFns } from "./RiskEvaluationSlot.vue?vue&type=template&id=15c29719&scoped=true"
import script from "./RiskEvaluationSlot.vue?vue&type=script&lang=js"
export * from "./RiskEvaluationSlot.vue?vue&type=script&lang=js"
import style0 from "./RiskEvaluationSlot.vue?vue&type=style&index=0&id=15c29719&prod&lang=scss&scoped=true"
import style1 from "./RiskEvaluationSlot.vue?vue&type=style&index=1&id=15c29719&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c29719",
  null
  
)

export default component.exports